import { useEffect, useState } from "react";
import PathElementDto from "../../../../../models/interfaces/dtos/path-element-dto.ts";
import { fetchItem } from "../../../../../queries/queries-helper.ts";
import ENDPOINTS from "../../../../../services/endpoints.ts";

const useProjectIfcFiles = (projectId: string) => {
    const [ifcFiles, setIfcFiles] = useState<PathElementDto[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!projectId) return;

        const fetchIfcFiles = async () => {
            setIsLoading(true);

            await fetchItem<PathElementDto[]>(ENDPOINTS.VIEWER_IFC_FILES_SAAS(projectId))
                .then((data) => {
                    if (data)
                        setIfcFiles(data);
                })
                .finally(() => setIsLoading(false));
        };

        fetchIfcFiles();

    }, [projectId]);

    return { ifcFiles, isLoading };
}

export default useProjectIfcFiles;